export default "/images/vendor/flag-icon-css/flags/4x3/bq.svg?8ff78ac28371e9069bfb5206d9704c9a";